import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import AppConsent from 'components/Consents/AppConsents/AppConsent'
import AppForm from 'components/Form/AppForm/AppForm'
import useAppFormLogic from 'components/Form/AppForm/hooks/useAppFormLogic'
import { mObywatelExtendedInfoForm } from 'FormDefinitions/MObywatelExtendedInfoForm/MObywatelExtendedInfoFormDefinition'
import { AppState } from 'store'
import videoVerificationService from 'service/VideoVerificationService/VideoVerificationService'


/**
 * Strona formularza zbierająca podstawowe informacje - przystosowana do ścieżki wideoweryfikacji 
*/
const VideoVerificationBasicInfoFormPage = (): JSX.Element => {
   const appConsents = useSelector((state: AppState) => state.consentsState.appConsents)
   const { handleVideoVerificationBasicInfoFormSubmitButtonClick } = useAppFormLogic({ form: mObywatelExtendedInfoForm })

   return ( 
      <AppForm form={{...mObywatelExtendedInfoForm, canStepBack: false}} handleSubmitButtonClick={(e: React.SyntheticEvent) => handleVideoVerificationBasicInfoFormSubmitButtonClick(e, appConsents)} >
         <AppConsent />
      </AppForm> 
   )
}

export default VideoVerificationBasicInfoFormPage